<template>
  <BaseForm
    :key="mileId || 'new'"
    :title="formTitle"
    :formData="mileData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Ensure the path is correct
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    mileId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      mileData: {
        customer_id: '',
        producer_id: '',
        field_id: '',
        miles: ''
      },
      fields: [
        { model: 'customer_id', label: 'Customer', required: true, type: 'select', optionsUrl: '/api/v1/customer/customers/', labelField: 'name' },
        { model: 'producer_id', label: 'Producer', required: true, type: 'select', optionsUrl: '/api/v1/producer/producers/', labelField: 'name' },
        { model: 'field_id', label: 'Field', required: true, type: 'select', optionsUrl: '/api/v1/field/fields/', labelField: 'name' },
        { model: 'miles', label: 'Miles', required: true, type: 'number' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.mileId ? `Edit Mileage` : 'Add Mileage';
    },
    submitUrl() {
      return this.mileId ? `/api/v1/mile/miles/${this.mileId}/` : '/api/v1/mile/miles/';
    },
    method() {
      return this.mileId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.mileId) {
      this.loadMileData();
    }
  },
  methods: {
    loadMileData() {
      axios.get(`/api/v1/mile/miles/${this.mileId}/`).then(response => {
        this.mileData = { ...response.data, 
          customer_id: response.data.customer_id.id, 
          producer_id: response.data.producer_id.id, 
          field_id: response.data.field_id.id }; // Adjust for nested object ids
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Mile information saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the mile information!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
